import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { IExtension } from '@tencent/ark-extensions';

/**
 * 跳转aisee/dcl反馈平台（我也不知道为啥有俩名字）
 * @param data 要上报的数据
 * @param jumpToSubmit true跳表单页，false跳首页
 */
export async function showDclReport(data?: any, jumpToSubmit?: boolean): Promise<IExtension> {
    await ArkLoader.initPromise;
    const dclReportExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);

    const endTs = Date.now();
    const startTs = endTs - (24 * 60 * 60 * 1000);
    window.log.report('USER_REPORT', {
        startTs,
        endTs,
    }).then((reportId) => {
        dclReportExtension.show({
            // slide固定id
            src: '1277',
            jumpToFeedback: true,
            jumpToSubmit,
            params: {
                custom_logId: reportId,
                custom_id: window.clientVars.collab_client_vars.client.upid,
                custom_customInfo: data ? JSON.stringify(data) : '',
            },
        });
    });
    return dclReportExtension;
}
